import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import UserMembershipForm from '../UserMembershipForm';
import CommitteesForm from '../CommitteesForm';
import MembershipsForm from '../MembershipsForm'; 
import UserPurchaseHistory from '../UserPurchaseHistory';
import { fetchStates } from '../../../../../../Redux/Actions/CommonActions';
import {
    fetchMembershipUsersByUser,
} from '../../../../../../Redux/Actions/Admin/ManageMembershipUserActions';
import {
    getUserCommittees,
} from '../../../../../../Redux/Actions/EndUser/AccountDetailsActions';
import MembershipUserAudit from '../MembershipUserAudit/MembershipUserAudit';

export class DialogContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: "details",
            states: null
        };
    }

    componentDidMount() {
        this.props.fetchMembershipUsersByUser(this.props.userId, this.props.membershipAssignmentId);
        this.props.getUserCommittees(this.props.userId);
        this.state.states = this.props.fetchStates();
    }

    changeView = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{ width: '100%' }}>
                    <div className="col-md-3">
                        <ul className="subSideNav">
                            <li onClick={() => this.changeView("details")} className={this.state.view === "details" ? "active" : "", "stylingli"} >Edit User Details</li>
                            <li onClick={() => this.changeView("committees")} className={this.state.view === "committees" ? "active" : "", "stylingli"} >Groups/Positions</li>
                            <li onClick={() => this.changeView("memberships")} className={this.state.view === "memberships" ? "history" : "", "stylingli"} >Memberships</li>
                            <li onClick={() => this.changeView("purchases")} className={this.state.view === "add" ? "active" : ""}>Purchase History</li>
                            <li onClick={() => this.changeView("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                        </ul>
                    </div>
                    <div className="col-md-9">
                        {this.state.view === "details" ?
                            <UserMembershipForm
                                dataItem={this.props.dataItem}
                                save={this.props.save}
                                cancel={this.props.cancel}
                                saveUserMembership={this.props.common.states}
                                states={this.props.common.states}
                                add={this.props.add}
                                modify={this.props.modify}
                            />
                            : ""}
                        {this.state.view === "committees" ?
                            <CommitteesForm
                                dataItem={this.props.dataItem}
                                save={this.props.save}
                                cancel={this.props.cancel}
                                saveAdminMembership={this.props.saveUserMembership}
                            />
                            : ""}
                        {this.state.view === "memberships" ?
                            <MembershipsForm
                                dataItem={this.props.dataItem}
                                save={this.props.save}
                                cancel={this.props.cancel}
                                saveAdminMembership={this.props.saveUserMembership}
                            />
                            : ""}
                        {this.state.view === "purchases" ?
                            <UserPurchaseHistory
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""} 
                        {this.state.view === "audit" ?
                            <MembershipUserAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                            : ""} 
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        common: state.common,
        membershipUsersDetails: state.membershipUser.membershipUsersDetails,
        userCommittees: state.accountDetails.userCommittees,
    };
}

export default connect(mapStateToProps, { fetchStates, fetchMembershipUsersByUser, getUserCommittees })(DialogContainer);